import { useParams } from "react-router-dom";
import { MuiPage } from "../../../components";
import { MuiAccordionArray } from "../../../components/MuiAccordionArray";
import { ModuleMenuMapping } from "./moduleMenuMapping";
import ModuleEdit from "./modules.edit";

export const ModulesAddEdit = (props: any) => {
    const { id } = useParams()

    const accordionArray = [
        {
            panelId: 'Panel1',
            name: ("Menu"),
            child: <ModuleMenuMapping request={{ ModuleId: id }} />
        },
    ]

    return (
        <MuiPage>
            <ModuleEdit />
            {!!id && (
                <MuiAccordionArray
                    accordionArray={accordionArray}
                />
            )}
        </MuiPage>
    );
}